import React from 'react';
import { Box, Container } from '@mui/material';

export default function DisplayStigReport() {

  return (
    <Container sx={{ maxWidth:1500, mt: 20, mb: 10 }}>
      <Box
        sx={{
          // position: 'relative',
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          height: '800px',
          overflow: 'hidden',
          borderRadius: 1,
        }}
      >
        <Box
          component="iframe"
          src="/stig/report.html"
          sx={{
            width: '100%',
            height: '100%',
            border: 0,
          }}
          loading="lazy"
        />
      </Box>
    </Container>
  )
}
